var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 182,
    viewBox: "0 0 183 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 182,
    height: 182,
    rx: 91,
    fill: "#F5FFF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_637_3990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1 68.0502V82.1502L47.25 75.2502L56.1 68.0502Z",
    fill: "#FBB553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.499 75.2499V75.0999V74.9499V74.7999C139.499 74.7999 139.499 74.6499 139.349 74.6499V74.4999L139.199 74.3499L127.049 64.4499V48.3999C127.049 47.6499 126.449 46.8999 125.549 46.8999H105.449L97.3494 40.2999C93.8994 37.5999 89.0994 37.5999 85.6494 40.2999L77.5494 46.8999H57.5994C56.8494 46.8999 56.0994 47.4999 56.0994 48.3999V64.4499L43.9494 74.3499C43.9494 74.3499 43.9494 74.3499 43.9494 74.4999C43.9494 74.4999 43.9494 74.4999 43.7994 74.6499L43.6494 74.7999V74.9499V75.0999C43.6494 75.0999 43.6494 75.2499 43.6494 75.3999V130.3V130.45C43.6494 130.6 43.6494 130.6 43.6494 130.75C43.6494 130.9 43.6494 130.9 43.7994 131.05V131.2L43.9494 131.35C44.0994 131.5 44.2494 131.5 44.3994 131.65C44.3994 131.65 44.3994 131.65 44.5494 131.65C44.6994 131.65 44.8494 131.8 44.9994 131.8H137.999C138.149 131.8 138.299 131.8 138.449 131.65C138.449 131.65 138.449 131.65 138.599 131.65C138.749 131.65 138.899 131.5 139.049 131.35L139.199 131.2V131.05C139.199 130.9 139.199 130.9 139.349 130.75C139.349 130.6 139.349 130.6 139.349 130.45C139.349 130.45 139.349 130.45 139.349 130.3L139.499 75.2499ZM126.899 68.0499L135.749 75.2499L126.899 81.9999V68.0499ZM87.4494 42.5499C89.8494 40.5999 93.1494 40.5999 95.5494 42.5499L100.799 46.8999H82.1994L87.4494 42.5499ZM59.0994 49.7499H124.049V84.2499L99.1494 103.45H83.8494L59.0994 84.3999V49.7499ZM56.0994 68.0499V81.9999L47.2494 75.2499L56.0994 68.0499ZM46.3494 78.2499L80.6994 104.8L46.3494 127.6V78.2499ZM49.7994 128.8L83.8494 106.3H99.2994L133.349 128.8H49.7994ZM136.649 127.6L102.149 104.8L136.499 78.2499V127.6H136.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1006 49.75V84.25L83.8506 103.3H99.1506L123.901 84.25V49.75H59.1006ZM114.001 87.1H69.0006C68.2506 87.1 67.5006 86.5 67.5006 85.6C67.5006 84.85 68.1006 84.1 69.0006 84.1H114.001C114.751 84.1 115.501 84.7 115.501 85.6C115.351 86.35 114.751 87.1 114.001 87.1ZM114.001 77.95H69.0006C68.2506 77.95 67.5006 77.35 67.5006 76.45C67.5006 75.7 68.1006 74.95 69.0006 74.95H114.001C114.751 74.95 115.501 75.55 115.501 76.45C115.351 77.35 114.751 77.95 114.001 77.95ZM114.001 68.8H69.0006C68.2506 68.8 67.5006 68.2 67.5006 67.3C67.5006 66.55 68.1006 65.8 69.0006 65.8H114.001C114.751 65.8 115.501 66.4 115.501 67.3C115.351 68.2 114.751 68.8 114.001 68.8ZM114.001 59.8H69.0006C68.2506 59.8 67.5006 59.2 67.5006 58.3C67.5006 57.55 68.1006 56.8 69.0006 56.8H114.001C114.751 56.8 115.501 57.4 115.501 58.3C115.351 59.2 114.751 59.8 114.001 59.8Z",
    fill: "#D5D6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9506 49.75V86.65L59.1006 84.4V49.75H61.9506Z",
    fill: "#EDECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.05 49.75V86.65L123.9 84.4V49.75H121.05Z",
    fill: "#BFBEBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2 128.8H49.7998L83.6998 106.3H99.2998L133.2 128.8Z",
    fill: "#2FCE70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2 128.8H49.7998L52.6498 126.85H130.35L133.2 128.8Z",
    fill: "#1ED167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.349 126.85H52.6494L58.6494 122.95H124.349L130.349 126.85Z",
    fill: "#6EFFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.649 78.25V127.6L102.149 104.8L136.649 78.25Z",
    fill: "#2FCE70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.749 75.2503L126.899 82.1503V68.0503L135.749 75.2503Z",
    fill: "#FBB553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.749 75.2503L134.249 76.3003L126.899 70.3003V68.0503L135.749 75.2503Z",
    fill: "#E8932F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.249 76.3003L131.849 78.2503L126.899 74.2003V70.3003L134.249 76.3003Z",
    fill: "#F1A444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25 75.2502L48.6 76.3002L56.1 70.3002V68.0502L47.25 75.2502Z",
    fill: "#E8932F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6006 76.3003L51.1506 78.2503L56.1006 74.2003V70.3003L48.6006 76.3003Z",
    fill: "#F1A444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8506 104.8L46.3506 127.6V78.25L80.8506 104.8Z",
    fill: "#2FCE70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7506 80.05V126.1L46.3506 127.6V78.25L48.7506 80.05Z",
    fill: "#1ED167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3 84.2502V122.35L48.75 126.1V80.0502L54.3 84.2502Z",
    fill: "#6EFFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.25 80.05V126.1L136.65 127.6V78.25L134.25 80.05Z",
    fill: "#1ED167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.7 84.2503V122.35L134.25 126.1V80.0503L128.7 84.2503Z",
    fill: "#6EFFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8 46.8999H82.2002L87.4502 42.5499C89.8502 40.5999 93.1502 40.5999 95.5502 42.5499L100.8 46.8999Z",
    fill: "#FBB553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8 46.8999H99.0002L95.4002 44.0499C93.1502 42.0999 89.7002 42.0999 87.4502 44.0499L84.0002 46.8999H82.2002L87.4502 42.5499C89.8502 40.5999 93.1502 40.5999 95.5502 42.5499L100.8 46.8999Z",
    fill: "#E8932F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 46.9001H96L95.4 46.4501C93 44.5001 89.7 44.5001 87.3 46.4501L87 46.9001H84L87.45 44.0501C89.85 42.1001 93.15 42.1001 95.4 44.0501L99 46.9001Z",
    fill: "#F1A444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.35 58.3002C115.35 59.0502 114.75 59.8002 113.85 59.8002H69C68.25 59.8002 67.5 59.2002 67.5 58.3002C67.5 57.5502 68.1 56.8002 69 56.8002H114C114.75 56.8002 115.35 57.5502 115.35 58.3002ZM115.35 67.4502C115.35 68.2002 114.75 68.9502 113.85 68.9502H69C68.25 68.9502 67.5 68.3502 67.5 67.4502C67.5 66.7002 68.1 65.9502 69 65.9502H114C114.75 65.9502 115.35 66.5502 115.35 67.4502ZM115.35 76.4502C115.35 77.2002 114.75 77.9502 113.85 77.9502H69C68.25 77.9502 67.5 77.3502 67.5 76.4502C67.5 75.7002 68.1 74.9502 69 74.9502H114C114.75 75.1002 115.35 75.7002 115.35 76.4502ZM115.35 85.6002C115.35 86.3502 114.75 87.1002 113.85 87.1002H69C68.25 87.1002 67.5 86.5002 67.5 85.6002C67.5 84.8502 68.1 84.1002 69 84.1002H114C114.75 84.1002 115.35 84.7002 115.35 85.6002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_637_3990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(43.5 37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfirm);
export default __webpack_public_path__ + "static/media/emailConfirm.1ac5a95caa3b3d526ed2b1094bd5cfb6.svg";
export { ForwardRef as ReactComponent };